import { useQuery } from "react-query"
import React, { FC, memo } from "react"
import { fetchProductsList } from "@/api/productsAPI"
import { ANALOGS_TITLE } from "@/components/Products/constants"
import { getBreakpointVal } from "@/styles/utils/Utils"
import { breakpoints } from "@/styles/utils/vars"
import { Typography } from "@/ui/Typography/Typography"
import {
  getMilisecondsHours,
  sortProductsWeightRule,
} from "@/utils/common/helpers"
import { ProductsContainerPropsType, ProductsSlider } from "../../Slider"

const AnalogsContainer: FC<{
  analogs: ProductsContainerPropsType["ruleSort"]
}> = memo(({ analogs = [] }) => {
  const uuids = analogs.map((item) => item.uuid).join(",")
  const { data: analogsData } = useQuery(
    ["analogs", uuids],
    () =>
      fetchProductsList({
        uuids: uuids,
        server: true,
      }),
    {
      enabled: uuids.length > 0,
      staleTime: getMilisecondsHours(1),
    },
  )

  const products = sortProductsWeightRule({
    products: analogsData || [],
    rules: analogs,
  })

  return (
    <ProductsSlider
      responsiveExtends={{
        [getBreakpointVal(breakpoints.lg)]: {
          slidesPerView: 3,
        },
        [getBreakpointVal(breakpoints.sm)]: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      }}
      products={products || []}
      ruleSort={analogs}
      title={{
        content: <Typography variant={"h3"}>{ANALOGS_TITLE}</Typography>,
      }}
    />
  )
})

AnalogsContainer.displayName = "AnalogsContainer"

export { AnalogsContainer }
